//scroll variable to track window's scroll
var lastScrollTop = 0;
var mobileW = 0;

//vanilla variables for resizing 
var w = window,
	d = document,
	e = d.documentElement,
	g = d.getElementsByTagName('body')[0],
	windowWidth = w.innerWidth || e.clientWidth || g.clientWidth,
	windowHeight = w.innerHeight || e.clientHeight || g.clientHeight;

(function(){

	$(document).ready(function () {


		document.querySelectorAll('.js-toggleBooking').forEach(btn => {
			btn.addEventListener('click', e => {
				e.preventDefault();

				const bookingID = btn.getAttribute('href');
				console.log(bookingID,'bookingid')
				if ( document.querySelector( bookingID ) ) {
					btn.classList.toggle('active');

					document.querySelector( bookingID ).classList.toggle('active');
					document.body.classList.toggle('noscroll', document.querySelector( bookingID ).classList.contains('active'));
				}
			});
		});

		// BOOKING WIDGET
        let bookingDateFormat = 'yy-mm-dd';
        let start, end, op = 0;
		const calendarBeforeShow = date => {
			if ( start !== undefined ){
				let startDate = $.datepicker.parseDate(bookingDateFormat, start);
				let endDate = $.datepicker.parseDate(bookingDateFormat, end);
				if ( date.getTime() == startDate.getTime() ) {
					return[ true, 'startday' ];
				} else {
					if ( date.getTime() == endDate.getTime() ) {
						return[ true, 'endday' ];
					} else {
						if( date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime() ){
							return[ true, 'days' ];
						} else {
							return[ true ];
						}
					}
				}
			} else{
				return[ true ];
			}
		};
		const calendarOnSelect = date => {
			start = (start !== undefined) ? start : $.datepicker.formatDate(bookingDateFormat, new Date());
			let startDate = $.datepicker.parseDate(bookingDateFormat, start);
			let selectedDate = $.datepicker.parseDate(bookingDateFormat, date);
			
			if ( op === 0 ) {
				op = 1;
				start = date;
				end =  date;  
			} else {
				op = 0;
				if(selectedDate <= startDate){
					end = start;
					start = date;  
				} else {
					end =  date; 
				}
			}

			$('#checkin').attr('value',start);
			$('#checkout').attr('value',end);
			let item = `${start} - ${end}` 
			item = item.split('-');
			item = `${item[1]} <span> </span>${item[2]}<span> </span>${item[0]} - ${item[4]}<span> </span>${item[5]}<span> </span>${item[3]}`
			$('#fakeInput')[0].innerHTML = item;
		};
		const calendarOptions = {
			minDate: 0,
			maxDate: '+1Y',
            numberOfMonths: 2,
            dateFormat: bookingDateFormat,
            beforeShowDay: calendarBeforeShow,
            onSelect: calendarOnSelect
		};
		$('#dateCalendar').datepicker( calendarOptions );


		

		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			$(this).addClass("hover");
			$('ul.submenu',this).fadeIn(200);
		  }, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);
		});

		// let jBooking = document.querySelector(".js-booking");
		// if (jBooking != undefined) {
		// 	jBooking.addEventListener("click", function (e) {
		// 		e.preventDefault();
		// 		document.querySelector(".booking-block").classList.add("open");
		// 	});
		// }

		// document.querySelector(".js-close").addEventListener("click", function (e) {
		// 	e.preventDefault();
		// 	document.querySelector(".booking-block").classList.remove("open");
		// });

	});

	window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

		//mobile burger menu
		document.getElementById('burgerMenu').addEventListener('click', function () {
			if (!this.classList.contains('open')) {
				this.parentElement.classList.add('open');
				this.classList.add('open');
				document.querySelector(".overlay").classList.add("open");
				document.getElementById("logo-sm").classList.remove("hidden");
				document.getElementById("social-mobile").classList.remove("hidden");

				let button = document.getElementById("Close").parentElement.parentElement;
				if (button.childNodes.length == 2) {
					let newText = document.createElement("div");
					newText.textContent = "CLOSE";
					newText.classList.add("jsCloseBtn") 
					button.appendChild(newText);
				}
			}
			else {
				this.classList.remove('open');
				document.getElementById("logo-sm").classList.add("hidden");
				document.getElementById("social-mobile").classList.add("hidden");

				let button = document.getElementById("Close").parentElement.parentElement;
				button.removeChild();
				this.parentElement.classList.remove('open');
				document.querySelector(".overlay").classList.remove("open");
			}
		});
	
		//close btn mobile
		let closeBtn = document.querySelectorAll(".nav-container")[0];
		let newButton = closeBtn.childNodes[1];
		if (newButton != undefined) {
			if (closeBtn.childNodes[1].classList.contains("mobile")) {
				let generalbutton = closeBtn.childNodes[1].children[0].children[0];
				generalbutton.addEventListener('click', function () {
					document.getElementById("logo-sm").classList.add("hidden");
					document.getElementById("social-mobile").classList.add("hidden");
					document.querySelectorAll('.overlay')[0].classList.remove('open');
					document.getElementById('burgerMenu').classList.remove('open');
				})
			}
		}

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}
function resizeWindow() { 
	//calculate a new window size
	windowWidth = w.innerWidth || e.clientWidth || g.clientWidth;
	windowHeight = w.innerHeight || e.clientHeight || g.clientHeight;

	//header image to be window height on homepage
	if (document.getElementsByClassName('img-slide').length > 0) {
		let headerImages = document.getElementsByClassName('img-slide');
		let headerImagesLength = headerImages.length;
		for (let i = 0; i < headerImagesLength; i++) {
			headerImages[i].style.height = (windowHeight + 10) + 'px';
		}
	}
}